const strings = {
  gaes: "Novos Atendimentos",
  desistentes: "Desistentes",
  hospital: {
    total_aguardando: "Aguardando Atendimento",
    total_aguardando_resumido: "Aguardando Atendimento",
    classificacao_risco: "Total por Classificação de Risco",
  },
  especialidade: {
    aguardando: "Pacientes Aguardando Atendimento",
    aguardando_resumido: "Aguardando Atendimento",
    classificacao_risco: "Classificação de Risco",
    tempoMedio: "Tempo Médio de Espera",
  },
};

export default strings;
